import { dispatch } from './store'

export const setProgress = (done: number, total: number) =>
    dispatch((draft) => {
        draft.progress = { done, total }
    })

export const clearProgress = () => dispatch((draft) => (draft.progress = null))
